import { gtm, selectElement } from 'tracking';
import {
  Action,
  DraftAction,
  DraftState,
  OptionType,
  State,
} from './interface';

/**
 * Utility function to track selected option.
 */
export const trackSelectedOption = (
  key: OptionType,
  selectedOption: string
): void => {
  gtm(
    selectElement({
      element: ['Need Capture', key, selectedOption],
    })
  );
};

/**
 * Reducer for the need capture state.
 */
export const reducer = (state: State, action: Action): State => {
  switch (action.type) {
    case 'TOGGLE_AGE_SELECTOR':
      return { ...state, isAgeSelectorOpen: !state.isAgeSelectorOpen };
    case 'TOGGLE_BREED_SELECTOR':
      return { ...state, isBreedSelectorOpen: !state.isBreedSelectorOpen };
    case 'TOGGLE_NEED_SELECTOR':
      return { ...state, isNeedSelectorOpen: !state.isNeedSelectorOpen };
    case 'SET_AGE': {
      const payload =
        action.payload === state.selectedAge ? undefined : action.payload;
      if (payload) trackSelectedOption('age', action.payload);

      return {
        ...state,
        selectedAge: payload,
        lastTouched: action.payload,
      };
    }
    case 'SET_BREED': {
      const payload =
        action.payload === state.selectedBreed ? undefined : action.payload;
      if (payload) trackSelectedOption('breed', action.payload);
      return {
        ...state,
        selectedBreed: payload,
        lastTouched: action.payload,
      };
    }
    case 'SET_NEEDS':
      if (action.payload.length > 0) {
        trackSelectedOption('need', action.payload.sort().join(','));
      }
      return {
        ...state,
        selectedNeeds: action.payload,
        lastTouched:
          action.payload[action.payload.length - 1] || state.lastTouched,
      };
    case 'SET_ALLERGIES':
      if (action.payload.length > 0) {
        trackSelectedOption('allergy', action.payload.sort().join(','));
      }
      return { ...state, selectedAllergies: action.payload };
    default:
      throw new Error();
  }
};

/**
 * Reducer for the draft state of needs and allergies.
 */
export const draftStateReducer = (
  state: DraftState,
  action: DraftAction
): DraftState => {
  switch (action.type) {
    case 'SET_DRAFT_NEEDS':
      return {
        ...state,
        draftNeeds: action.payload,
        lastTouched:
          action.payload[action.payload.length - 1] || state.lastTouched,
      };
    case 'SET_DRAFT_ALLERGIES':
      return {
        ...state,
        draftAllergies: action.payload,
      };
    default:
      throw new Error();
  }
};
